import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link, useLocation } from "react-router-dom";
import { Dropdown, Menu, Button, Badge } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import TableComponent from "../../Global Functions/tableComponents";

const ViewCategory = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const clickedCategoryName = queryParams.get("name");

  const { id: fetchedId } = useParams();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = (page, pageSize) => {
    const subCategoriesData = {
      page,
      limit: pageSize,
      category_id: fetchedId,
      sort: { createdAt: -1 },
    };
    dispatch(viewCategoryList(subCategoriesData));
  };


  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedId]);

  const { categories } = useSelector((state) => state.categories);

  useEffect(() => {
    if (categories?.total) {
      setPagination((prevData) => ({ ...prevData, total: categories.total }));
    }
  }, [categories]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const dispatch = useDispatch();

  const getDropDownMenu = (record) => (
    <Menu>
      {canEdit &&
        <Link to={`/categories/view/sub/edit/${record._id}`}>
          <Menu.Item key="edit">Edit</Menu.Item>
        </Link>
      }
    </Menu>
  );

  const columns = [
    {
      title: "Sr No.",
      align: "center",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Sub - Category Name",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "Image",
      align: "center",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <img
          src={image ? image : require("../../Global Icons/No Data.jpg")}
          alt="No Data"
          style={{ borderRadius: "20px", height: "50px", width: "100px" }}
        />
      ),
    },
    {
      title: "Icon",
      align: "center",
      dataIndex: "icon",
      key: "icon",
      render: (icon) => (
        <img
          src={icon ? icon : require("../../Global Icons/No Data.jpg")}
          alt="No Icon"
          style={{ borderRadius: "20px", height: "50px", width: "100px" }}
        />
      ),
    },
    {
      title: "3D Icon",
      align: "center",
      dataIndex: "three_d_icon",
      key: "three_d_icon",
      render: (icon) => (
        <img
          src={icon ? icon : require("../../Global Icons/No Data.jpg")}
          alt="No Icon"
          style={{ borderRadius: "20px", height: "50px", width: "100px" }}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (status) => (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 8px",
            border: "1px solid #d9d9d9",
            borderRadius: "10px",
          }}
        >
          <Badge
            color={status === "active" ? "green" : "red"}
            text={status.charAt(0).toUpperCase() + status.slice(1)}
            background
          />
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Dropdown overlay={getDropDownMenu(record)} trigger={["click"]}>
          <Button shape="square" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <TableComponent
      h3heading={clickedCategoryName ? clickedCategoryName : "No Data"}
      buttonhead2={canAdd ? "Add Sub Category" : null}
      navigateTo2={canAdd ? `/categories/${fetchedId}/sub/add` : null}
      buttonhead="Go Back"
      navigateTo={`/categories`}
      columns={columns}
      dataSource={(Array.isArray(categories?.data) && categories.data) || []}
      rowKey="_id"
      pagination={pagination}
      onChange={handleTableChange}
    ></TableComponent>
  );
};

export default ViewCategory;
